export const fontSizes = {
    normal: '1rem',
    medium: '1.3rem',
    big: '1.5rem',
    heading: '2rem',
};

